import { useMemo } from 'react'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { HistoricoValorProfissionalList, ValorProfissionalList } from '../core/_models'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { profissionalValoresColumns, profissionalValoresHistoricoColumns } from './columns/_columns'
import { useT } from '_metronic/i18n/Metronici18n'

export const ProfissionalValoresTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { state } = useQueryRequest()
  const { t } = useT()

  const colsValores = useMemo(() => profissionalValoresColumns(t), [t])
  const colsHistorico = useMemo(() => profissionalValoresHistoricoColumns(t), [t])
  const historico = state.tab === 'historico'

  const emptyState = historico ? (
    <TableEmptyState
      title='Nenhum valor no histórico'
      description='Ainda não há valores anteriores registrados.'
    />
  ) : (
    <TableEmptyState
      title='Nenhum valor encontrado'
      description='Revise os filtros ou use “Novo valor” para cadastrar um valor.'
    />
  )

  const tableProps = {
    itemLabel: { singular: 'valor', plural: 'valores' },
    isLoading,
    isError,
    onRetry: refetch,
    emptyState,
    queryHooks: { useQueryRequest, useQueryResponse },
  }

  if (historico) {
    return (
      <CustomTable<HistoricoValorProfissionalList>
        {...tableProps}
        id='kt_table_profissional_historico_valores'
        ariaLabel='Histórico de valores'
        data={(response?.data as HistoricoValorProfissionalList[]) || []}
        columns={colsHistorico}
      />
    )
  }

  return (
    <CustomTable<ValorProfissionalList>
      {...tableProps}
      id='kt_table_profissional_valores'
      ariaLabel='Valores atuais'
      data={(response?.data as ValorProfissionalList[]) || []}
      columns={colsValores}
    />
  )
}
